import './style.modules.scss'

import { Spacer, SpacerSpacing } from '@ampcore/adel-react'
import { BackgroundColor } from '@ampcore/ampcom-contracts'
import React from 'react'
import xss from 'xss'

import { FacetImage } from '../FacetImage/FacetImage'
import { Image } from '../Image/Image'
import { HeroSectionFrontBackgroundColor } from './HeroSectionFrontColor.type'
import { HeroSectionFrontTemplate } from './HeroSectionFrontTemplate.type'

export type HeroSectionFrontProps = {
  heading?: string
  body?: string
  image?: string
  imageMobile?: string
  textAlignment?: string
  facetColor?: HeroSectionFrontBackgroundColor
  hideMobileImage?: string
  componentSpacing?: SpacerSpacing
  template?: HeroSectionFrontTemplate
  testId?: string
}

export const HeroSectionFront = (props: HeroSectionFrontProps) => {
  const {
    heading,
    body,
    image,
    imageMobile,
    textAlignment,
    facetColor = BackgroundColor.MIDNIGHT_BLUE,
    hideMobileImage,
    componentSpacing,
    template,
    testId
  } = props

  const showMobileImage = hideMobileImage !== 'true'

  const largeFacet = `${
    window.AMPCOMPATH
  }images/facets/heroes/section-front/desktop/${
    facetColor || BackgroundColor.MIDNIGHT_BLUE
  }.svg`
  const mobileFacet = `${
    window.AMPCOMPATH
  }images/facets/heroes/section-front/mobile/${
    facetColor || BackgroundColor.MIDNIGHT_BLUE
  }.svg`

  if (template === HeroSectionFrontTemplate.HERO_CAMPAIGN) {
    return (
      <Spacer spacing={componentSpacing}>
        <section className="HeroSectionFront" data-analytics-container="Hero">
          <div className="HeroSectionFront-content">
            <Image
              src={largeFacet}
              sm={mobileFacet}
              className="HeroSectionFront-facet HeroSectionFront-facet--campaign"
              testId={testId ? `${testId}-campaign-hero-facet` : undefined}
            />
            <div
              className={`u-paddingBottom64 u-paddingTop64 u-sm-paddingBottom48 u-sm-paddingTop48 u-posRelative`}
            >
              {image && (
                <Image
                  src={image}
                  sm={showMobileImage ? imageMobile : undefined}
                  className="HeroSectionFront-featuredImage u-block u-md-sizeFull u-sizeConstrained"
                  testId={testId ? `${testId}-image` : undefined}
                  priority={true}
                />
              )}
            </div>
            <div className="HeroSectionFront-heading u-sizeConstrained">
              {heading && (
                <h1
                  className={`HeroSectionFront--campaignHeading Type-Display ${textAlignment}`}
                  dangerouslySetInnerHTML={{ __html: xss(heading) }}
                  data-testid={
                    testId ? `${testId}-campaign-hero-heading` : null
                  }
                ></h1>
              )}
              {body && (
                <div
                  className={`Content Content--large u-paddingTop8 ${textAlignment}`}
                  dangerouslySetInnerHTML={{ __html: xss(body) }}
                  data-testid={testId ? `${testId}-campaign-hero-body` : null}
                ></div>
              )}
            </div>
          </div>
        </section>
      </Spacer>
    )
  }

  //  defaults to HeroSectionFrontTemplate.HERO_SECTION_FRONT
  return (
    <Spacer spacing={componentSpacing}>
      <section className="HeroSectionFront" data-analytics-container="Hero">
        <FacetImage
          color={facetColor}
          src={largeFacet}
          sm={mobileFacet}
          className="HeroSectionFront-facet"
          testId={testId ? `${testId}-facet` : undefined}
        />
        <div className="HeroSectionFront-content">
          <div className="HeroSectionFront-heading HeroSectionFront-heading--sectionFront u-size9of12 u-sm-sizeFull u-paddingTop48 u-sm-paddingTop64 u-paddingBottom40 u-sizeConstrained">
            {heading && (
              <h1
                className={`u-textColorWhite ${textAlignment}`}
                dangerouslySetInnerHTML={{ __html: xss(heading) }}
                data-testid={testId ? `${testId}-heading` : null}
              ></h1>
            )}
            {body && (
              <div
                className={`Content Content--large Content--reversed u-paddingTop8 u-textColorWhite ${textAlignment}`}
                dangerouslySetInnerHTML={{ __html: xss(body) }}
                data-testid={testId ? `${testId}-body` : null}
              ></div>
            )}
          </div>
          <div className={`u-posRelative`}>
            {image && (
              <Image
                src={image}
                sm={showMobileImage ? imageMobile : undefined}
                className="HeroSectionFront-featuredImage u-block u-md-sizeFull u-sizeConstrained"
                testId={testId ? `${testId}-image` : undefined}
                priority={true}
              />
            )}
          </div>
        </div>
      </section>
    </Spacer>
  )
}
